import { Component, ContentChild, ViewChild, OnInit } from '@angular/core';
import { MatFormField, MatFormFieldControl } from '@angular/material/form-field';

@Component({
    selector: 'hom-mat-field',
    templateUrl: './mat-field.component.html',
    styleUrls: ['./mat-field.component.scss'],
    standalone: false
})
export class MatFieldComponent implements OnInit {
  @ContentChild(MatFormFieldControl) _control: MatFormFieldControl<any>;
  @ViewChild(MatFormField) _matFormField: MatFormField;

  constructor() { }

  public ngOnInit(): void {
    this._matFormField._control = this._control;
  }

}
